module.exports = __webpack_public_path__ + "static/media/RecomendaRecife.7054aadd.jpg";